var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdvert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 -2 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.83904 8.91481H1.53254C0.68614 8.91481 0 8.26137 0 7.45531V6.6213C0 5.81524 0.686139 5.1618 1.53253 5.1618H2.40827C2.61606 5.1618 2.81419 5.20118 2.99488 5.27253L10.1701 2.60326C11.1751 2.22941 12.2603 2.93523 12.2603 3.96273V10.1137C12.2603 11.1412 11.1751 11.847 10.1701 11.4732L4.90411 9.51418V12.0423C4.90411 12.8484 4.21797 13.5018 3.37158 13.5018C2.52518 13.5018 1.83904 12.8484 1.83904 12.0423V8.91481ZM13.3333 6.50183C12.9934 6.50183 12.7179 6.77046 12.7179 7.10183C12.7179 7.4332 12.9934 7.70183 13.3333 7.70183H15.3846C15.7245 7.70183 16 7.4332 16 7.10183C16 6.77046 15.7245 6.50183 15.3846 6.50183H13.3333ZM12.938 4.90182C12.768 4.61484 12.8689 4.24789 13.1632 4.0822L14.9397 3.0822C15.234 2.91652 15.6104 3.01484 15.7803 3.30182C15.9503 3.58879 15.8494 3.95575 15.5551 4.12143L13.7786 5.12143C13.4843 5.28712 13.1079 5.18879 12.938 4.90182ZM13.7785 9.0821C13.4841 8.91642 13.1078 9.01474 12.9378 9.30172C12.7679 9.5887 12.8687 9.95565 13.1631 10.1213L14.9396 11.1213C15.2339 11.287 15.6103 11.1887 15.7802 10.9017C15.9501 10.6147 15.8493 10.2478 15.5549 10.0821L13.7785 9.0821Z",
    fill: "#8FBCF1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvert);
export default __webpack_public_path__ + "static/media/advert.6d07c8317668b5ef5c5ec25f06cda9b5.svg";
export { ForwardRef as ReactComponent };